import React from 'react';
import { MobileGenericHeader } from 'components/MobileGenericHeader';
import { SET_PROFILE_LAYOUT_TYPE } from 'containers/ProfileManager/redux/profile.types';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import { useDispatch, useSelector } from 'react-redux';
import { getTranslation } from 'utils/getTranslation';
import { ProfilesHeader } from '../ProfilesHeader';
import { ProfileImagePreview } from './components/ProfileImagePreview';
import { ProfileImagesCarousel } from './components/ProfileImagesCarousel';
import './style.scss';

export const SelectProfileImgView = () => {
  const dispatch = useDispatch();
  const translations = useSelector(state => state.translations);
  const { avatars, prevLayout } = useSelector(state => state.profilesManager);
  const { isMobile } = useVerifyIsMobile();

  const handleBackClick = () => {
    dispatch({ type: SET_PROFILE_LAYOUT_TYPE, payload: prevLayout });
  };

  return (
    <div className={'select-profile-img-view__wrapper'}>
      <MobileGenericHeader
        onBack={handleBackClick}
        caption={'Cambiar imagen'}
      />
      <section className="select-profile-img-view">
        {!isMobile && <ProfilesHeader />}
        <h2 className="select-profile-img-view__title">
          {getTranslation('avatarSelector_access_title_label', translations)}
        </h2>
        <ProfileImagePreview />
        <div className="select-profile-img-view__carousels">
          {avatars?.map((avatar, index) =>
            index === avatars.length - 1 ? (
              <></>
            ) : (
              <ProfileImagesCarousel
                key={`avatar-carousel-${avatar.name}`}
                avatarConfig={avatar}
                isMobile={isMobile}
              />
            ),
          )}
        </div>
      </section>
    </div>
  );
};
